import Rule from "./rule";

class CartAttributesRule extends Rule {
  type = "cart.attributes";

  constructor(config = {}) {
    super(config);
  }

  evaluate(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Config', this.config);
    const pass = this.config.attributes.every(attributeCondition => {
      const { key, value } = attributeCondition;
      const actualValue = data.response.attributes[key]?.toString();
      const result = actualValue === value.toString();

      this.addLog(result, `${key}=${value}`, `${key in data.response.attributes ? key+"="+(actualValue || 'undefined') : 'Key not found'}`);

      return result;
    });

    console.log('Pass?', pass);
    console.groupEnd();
    return pass;
  }

  explain() {
    return this.config.attributes.map(({ key, value }) => `cart has ${this.config.attributes.length !== 1 ? 'attributes' : 'attribute'} '${key}' = '${value}'`).join(' and ');
  }
}

export default CartAttributesRule;